import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { NgSelectComponent } from "@ng-select/ng-select";
import { CountryModel, TargetingModel, TargetingState } from "app/interfaces";
import { CommonService } from "app/services";
import { concat, Observable, of, Subject } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from "rxjs/operators";

@Component({
  selector: "app-targeting",
  templateUrl: "./targeting.component.html",
  styleUrls: ["./targeting.component.scss"],
})
export class TargetingComponent implements OnInit, OnChanges {
  @Input() target: any = null;
  @Input() state: TargetingState = null;
  @Input() position: any = null;
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onAdd: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild("fc") fc: NgSelectComponent;
  @ViewChild("ci") ci: NgSelectComponent;

  public t = new Date().getTime();

  public isCollapsed: boolean = true;

  public collapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  facultiesAndCoursesVisible = false;
  citiesAndInstitutesVisible = false;
  countriesAndInstitutesVisible = false;

  showSample: "field-of-study" | "country-univerity" | false = false;

  studyTags$: Observable<any>;
  studyTagsLoading = false;
  studyTagsInput$ = new Subject<string>();

  universities$: Observable<any>;
  universitiesLoading = false;
  universitiesInput$ = new Subject<string>();

  macroStudytags: any[] = null;
  cities: any[] = null;
  countries: CountryModel[];

  targeting: TargetingModel = new TargetingModel();

  sampleTargeting: TargetingModel = new TargetingModel();

  studyTagModel = [];
  instituteModel;

  _pos: any = null;
  originalTargetInput: any = null;

  constructor(private commonService: CommonService) { }

  selectTarget() {
    this.isCollapsed = true;
    this.onSelect.emit(this.target);
  }

  editTarget() {
    this.onEdit.emit(this.target);
  }

  deleteTarget() {
    this.onDelete.emit(this.target);
  }

  addTarget() {
    this.onAdd.emit({
      position: this.position,
      target: this.targeting,
    });
    // this.targeting = new TargetingModel();
  }

  onchange($event) {
    // console.log($event);
    this.targeting.study_tags = this.targeting.study_tags_ids;
    this.targeting.institutes = this.targeting.institutes_ids;
    return;
    try {
      this.fc.filterValue = null;
      this.fc.typeahead.next("");
    } catch (e) { }
    try {
      this.ci.filterValue = null;
      this.ci.typeahead.next("");
    } catch (e) { }
  }

  addMacroStudyTag(item: any) {
    if (this.macroStudyTagAlreadyAdded(item)) {
      return;
    }
    this.targeting.macro_study_tags_ids.push(item);
    this.targeting.macro_study_tags.push(item);
    // this.studyTagsInput$.next("");
    this.fc.filterValue = null;
    this.fc.typeahead.next("");
  }

  removeMacroStudyTag(item: any) {
    this.targeting.macro_study_tags_ids =
      this.targeting.macro_study_tags_ids.filter((mst) => mst !== item);
    this.targeting.macro_study_tags = this.targeting.macro_study_tags.filter(
      (mst) => mst !== item
    );
  }

  addCity(item: any) {
    this.targeting.cities_ids.push(item);
    this.targeting.cities.push(item);

    this.ci.filterValue = null;
    this.ci.typeahead.next("");
  }

  removeCity(item: any) {
    this.targeting.cities_ids = this.targeting.cities_ids.filter(
      (c) => c !== item
    );
    this.targeting.cities = this.targeting.cities.filter((c) => c !== item);
  }

  addCountry(item: any) {
    this.targeting.countries_ids.push(item);
    this.targeting.countries.push(item);

    this.ci.filterValue = null;
    this.ci.typeahead.next("");
  }

  removeCountry(item: any) {
    this.targeting.countries_ids = this.targeting.countries_ids.filter(
      (c) => c !== item
    );
    this.targeting.countries = this.targeting.countries.filter(
      (c) => c !== item
    );
  }

  removeStudyTag(item: any) {
    this.targeting.study_tags_ids = this.targeting.study_tags_ids.filter(
      (st) => st !== item
    );
    this.targeting.study_tags = this.targeting.study_tags.filter(
      (st) => st !== item
    );
  }

  removeInstitute(item: any) {
    this.targeting.institutes_ids = this.targeting.institutes_ids.filter(
      (i) => i !== item
    );
    this.targeting.institutes = this.targeting.institutes.filter(
      (i) => i !== item
    );
  }

  macroStudyTagAlreadyAdded(item: any): boolean {
    return (
      this.targeting.macro_study_tags_ids.filter((mst) => {
        // console.log('---------');
        // console.log(item, mst);
        // console.log(JSON.stringify(mst), JSON.stringify(item));
        // console.log('---------');
        // return JSON.stringify(mst) === JSON.stringify(item);
        return mst.id === item.id;
      }).length > 0
    );
  }

  cityAlreadyAdded(item: any): boolean {
    // return this.targeting.cities_ids.filter(c => c === item).length > 0;
    return (
      this.targeting.cities_ids.filter(
        (c) => JSON.stringify(c) === JSON.stringify(item)
      ).length > 0
    );
  }

  countryAlreadyAdded(item: any): boolean {
    // return this.targeting.cities_ids.filter(c => c === item).length > 0;
    return (
      this.targeting.countries_ids.filter(
        // (c) => JSON.stringify(c) === JSON.stringify(item)
        (c) => c.id === item.id
      ).length > 0
    );
  }

  ngOnInit() {
    this.loadStudyTags();
    //if (!this.macroStudytags || this.macroStudytags.length === 0) {
    this.commonService.getJobMacroStudyTag().subscribe((r) => {
      this.macroStudytags = r;
    });
    // }
    this.loadUniversities();
    // console.log(this.target);
    this.originalTargetInput = this.target;
    this.targeting = new TargetingModel(this.target);
    // console.log(this.position);
    // console.log("target", this.target);
    // console.log("targeting", this.targeting);

    this.sampleTargeting = {
      study_tags: [
        { name: "Managerial Economics" },
        { name: "Economics and Law" },
        { name: "Finance" },
        { name: "Accounting" },
      ],
      macro_study_tags: [{ name: "Economics" }, { name: "Marketing" }],
      countries: [
        { name: "Spain", id: 0 },
        { name: "France", id: 1 },
      ],
      institutes: [
        {
          name: "Universität der Künste Berlin, Germany",
        },
        { name: "Humboldt-Universität zu Berlin, Germany" },
      ],
      study_tags_ids: [],
      macro_study_tags_ids: [],
      countries_ids: [],
      institutes_ids: [],
      cities: [],
      cities_ids: [],
    };
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ngOnInit();
    // console.log(this.position);
  }

  trackByFn(item: any) {
    return item.id;
  }

  private loadStudyTags() {
    let _term: string = null;
    this.studyTags$ = concat(
      // of([]), // default items
      this.commonService.getJobStudyTags(),
      this.studyTagsInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.studyTagsLoading = true)),
        debounceTime(300),
        switchMap((term) => {
          _term = term;
          return this.commonService.getJobStudyTags(term).pipe(
            catchError(() => of([])), // empty list on error
            tap(() => (this.studyTagsLoading = false))
          );
        }),
        tap(() => {
          this.macroStudytags = null;
          // if (!_term) {
          //   return;
          // }
          this.commonService.getJobMacroStudyTag(_term).subscribe((r) => {
            this.macroStudytags = r;
          });
        })
      )
    );
  }

  private loadUniversities() {
    let _term: string = null;
    this.universities$ = concat(
      of([]), // default items
      this.universitiesInput$.pipe(
        distinctUntilChanged(),
        tap(() => (this.universitiesLoading = true)),
        debounceTime(300),
        switchMap((term) => {
          _term = term;
          return this.commonService
            .getJobUniversities(term, this.targeting.countries_ids)
            .pipe(
              map((r) => r.list),
              catchError(() => of([])), // empty list on error
              tap(() => (this.universitiesLoading = false))
            );
        }),
        tap(() => {
          this.countries = null;
          if (!_term) {
            return;
          }
          this.commonService.getJobCountries(_term).subscribe((r) => {
            this.countries = r;
            return;
            this.countries = r.filter(
              (c) => c.name.toLowerCase().indexOf(_term) > -1
            );
          });
          return;
        })
      )
    );
  }
}
